import LegalLayout, { type LegalSection } from "./components/LegalLayout";

const sections: LegalSection[] = [
  {
    id: "overview",
    heading: "Overview",
    paragraphs: [
      "This Master Service Agreement (\"MSA\") sets out the general terms under which Voxmaster LLC (\"Voxmaster\") provides wholesale voice termination, DID origination, SIP trunking, and related services to its customers. Specific pricing, destinations, and service levels are documented in individual service orders, which are incorporated by reference into this MSA.",
    ],
  },
  {
    id: "services",
    heading: "Services and Service Orders",
    paragraphs: [
      "Voxmaster will provide the services described in each service order accepted by both parties. Each service order identifies the services, rates, term, and any specific terms applicable to that order. In the event of a conflict between this MSA and a service order, the service order will control with respect to the specific services it covers.",
    ],
  },
  {
    id: "service-levels",
    heading: "Service Levels and Quality",
    paragraphs: [
      "Voxmaster is committed to carrier-grade quality and provides performance reporting including ASR (Answer Seizure Ratio), PDD (Post Dial Delay), and ACD (Average Call Duration). Unless a specific SLA is set out in a service order, the following generally apply:",
    ],
    items: [
      "Network availability target of 99.9% for the core routing fabric.",
      "Proactive routing to best-performing carriers based on live quality monitoring.",
      "Fraud monitoring and destination risk scoring applied across all traffic.",
      "24/7 NOC support for emergency and quality-related issues.",
    ],
  },
  {
    id: "pricing-billing",
    heading: "Pricing and Billing",
    paragraphs: [
      "Rates are set out in the applicable service order and may be adjusted in accordance with the terms of that order. Invoices are issued in accordance with the billing cycle specified in the service order. Payment terms, currency, and any applicable taxes are described in the relevant service order.",
    ],
  },
  {
    id: "compliance",
    heading: "Compliance and Regulatory Requirements",
    paragraphs: [
      "Both parties agree to comply with all applicable laws, regulations, and industry standards governing telecommunications services, including those relating to lawful intercept, number portability, and fraud prevention. Each party is responsible for the regulatory compliance of the traffic it originates.",
    ],
  },
  {
    id: "fraud-prevention",
    heading: "Fraud Prevention",
    paragraphs: [
      "Voxmaster employs fraud detection and traffic monitoring to protect the network. We may suspend traffic where there is a reasonable basis to believe it is fraudulent or unlawful. Both parties will cooperate in good faith to investigate and remediate fraud-related incidents and disputes.",
    ],
  },
  {
    id: "confidentiality",
    heading: "Confidentiality",
    paragraphs: [
      "Each party agrees to maintain the confidentiality of the other party's non-public information, including pricing, technical information, and business data, and to use such information solely for the purpose of performing under this MSA. This obligation survives termination of the MSA.",
    ],
  },
  {
    id: "term-termination",
    heading: "Term and Termination",
    paragraphs: [
      "The term of each service order is set out in the service order. Either party may terminate a service order for a material breach that remains uncured for thirty (30) days following written notice, or immediately upon the other party's insolvency. Termination does not relieve either party of accrued obligations.",
    ],
  },
  {
    id: "liability",
    heading: "Limitation of Liability",
    paragraphs: [
      "Except for a party's indemnification, confidentiality, or payment obligations, neither party will be liable for indirect, incidental, special, or consequential damages. Each party's aggregate liability arising out of or related to this MSA will not exceed the amounts paid or payable by the customer in the twelve (12) months preceding the event giving rise to the claim.",
    ],
  },
  {
    id: "general",
    heading: "General Provisions",
    paragraphs: [
      "This MSA constitutes the entire agreement between the parties with respect to its subject matter and supersedes all prior agreements. It is governed by the laws of the State of Nevada. Neither party may assign this MSA without the other's prior written consent, except in connection with a merger or sale of substantially all assets.",
    ],
  },
];

export default function Msa() {
  return (
    <LegalLayout
      title="Master Service Agreement"
      updated="August 15, 2026"
      intro="This Master Service Agreement governs the provision of wholesale voice termination, DID origination, and SIP trunking services by Voxmaster LLC, together with the individual service orders that reference it."
      sections={sections}
      active="msa"
    />
  );
}